// material-ui
import { useSelector } from 'react-redux'
import { useTranslation } from 'react-i18next'

import AddCircleOutlineOutlinedIcon from '@mui/icons-material/AddCircleOutlineOutlined'
import { Box, Button, Typography } from '@mui/material'
import { useTheme } from '@mui/material/styles'

import ModalContext from 'contexts/modalContext'
import ProjectModal from 'modals/ProjectModal'

import useModals from 'hooks/useModals'

import { AvatarButton } from '@contenthouse/components'
import { useSetState } from '@contenthouse/hooks'

// ==============================|| ACTION ||============================== //

const callbacks = (component, setState) => {
  const componentCallbacks = {
    ProjectModal: {
      closeModal: () => setState({ showProjectModal: false }),
    },
  }

  return componentCallbacks[component] || {}
}

const defaultState = {
  showProjectModal: false,
}

const ActionSection = () => {
  const { t } = useTranslation('common')
  const theme = useTheme()

  const { currentUser } = useSelector((state) => state.customization)

  const [state, setState] = useSetState(defaultState)
  const { showProjectModal } = state

  const modalContext = useModals()
  const {
    callbacks: { setModalData },
  } = modalContext

  const showModal = (payload) => {
    setModalData('ProjectModal', payload)
    setState({ showProjectModal: true })
  }

  return (
    <ModalContext.Provider value={modalContext}>
      {currentUser?.username ? (
        <Box sx={{ ml: 2 }}>
          <Box sx={{ display: { xs: 'block', md: 'none' } }}>
            <AvatarButton
              background={theme.palette.primary.light}
              color={theme.palette.primary.dark}
              callbacks={{ toggleClick: () => showModal() }}
              tooltip={t('newProject')}
              size={34}
            >
              <AddCircleOutlineOutlinedIcon fontSize="inherit" />
            </AvatarButton>
          </Box>
          <Button
            variant="contained"
            disableElevation
            endIcon={<AddCircleOutlineOutlinedIcon />}
            onClick={() => showModal()}
            sx={{
              display: { xs: 'none', md: 'flex' },
              lineHeight: 1,
              height: 34,
              transition: 'all .2s ease-in-out',
              background: theme.palette.primary.light,
              color: theme.palette.primary.dark,
              '&[aria-controls="menu-list-grow"],&:hover': {
                background: theme.palette.primary.dark,
                color: theme.palette.primary.light,
              },
            }}
          >
            <Typography variant="buttonText">{t('newProject')}</Typography>
          </Button>
          <ProjectModal callbacks={callbacks('ProjectModal', setState)} showModal={showProjectModal} />
        </Box>
      ) : null}
    </ModalContext.Provider>
  )
}

export default ActionSection
